// extracted by extract-css-chunks-webpack-plugin
module.exports = {"SiteInfoInnerPane":"SiteInfoInnerPane_Ts8Zp_v16-5-1"};